export default [
    {
        path: '/admin/academic/certificate-operation-prints',
        name: 'certificate-operation-print',
        meta: { requiresAuth: true },
        component: () => import('@/pages/academic/certificate-operation-print/index.vue')
    },
    {
        path: '/admin/academic/certificate-operation-prints/certificate-operation-print-approve/:candidate_id/:exam_register_id/:printing_id/:certificate_id',
        name: 'certificate-operation-print-approve',
        meta: { requiresAuth: true },
        component: () => import('@/pages/academic/certificate-operation-print/certificate-operation-print-approve.vue')
    },
]
